import firebaseApp from '../../utils/firebase'
import TimeMe from 'timeme.js'
import { w } from '../../utils/helpers'

export default {
  postPageHistory({ getters, dispatch }) {

    const sid = getters.bindSID
    const uid = getters.bindUID
    const reload = window.performance && window.performance.navigation && window.performance.navigation.type
    const url = location.href

    if (url.indexOf(w.app('popout'))>=0 || !sid)
      return

    let lastPage = getters.getLastPage
    let key = null
    let historyKey = getters.getHistoryKey
    let historySubKey = getters.getHistorySubKey

    if (reload &&
      !historyKey &&
      lastPage &&
      lastPage.url == url
    ) {
      key = lastPage.pageKey
      dispatch('updatePage', key)
      dispatch('updatePageFocus', true)
    }
    else {

      if (historyKey)
        dispatch('disconnectHistory')

      key = firebaseApp.ref.child('history')
        .child(sid)
        .child('pages')
        .push({
          from: uid,
          created_at: firebaseApp.TIMESTAMP,
          title: document.title,
          referrer: document.referrer,
          focused: true,
          url
        })
        .key

      dispatch('updatePage',key)

    }


  },
  updatePageFocus({ getters }, focused) {

    const sid = getters.getHistorySid
    const key = getters.getHistoryKey

    if (key && sid) {
      let pageRef = firebaseApp.ref
        .child('history')
        .child(sid)
        .child('pages')
        .child(key)
        .update({
          focused
        })
    }

  },
  updatePage({ getters,commit }, key) {

    const sid = getters.bindSID

    if (!sid)
      return null

    let pageRef = firebaseApp.ref
      .child('history')
      .child(sid)
      .child('pages')
      .child(key)

    let pkey = pageRef.child('data').push({
      created_at: firebaseApp.TIMESTAMP
    }).key

    commit('setHistorySid', sid)
    commit('setHistoryKey', key)
    commit('setHistorySubKey', pkey)

    pageRef
      .child('left_at')
      .set('')

    pageRef
      .child('left_at')
      .onDisconnect()
      .set(firebaseApp.TIMESTAMP)

    pageRef
      .child('data')
      .child(pkey)
      .child('left_at')
      .onDisconnect()
      .set(firebaseApp.TIMESTAMP)

    //console.log('updatePage processed.')

  },
  disconnectHistory({ getters, commit }) {

    let sid = getters.getHistorySid
    let historyKey = getters.getHistoryKey
    let historySubKey = getters.getHistorySubKey

    if (!sid || !historyKey || !historySubKey)
      return null

    let pageRef = firebaseApp.ref
      .child('history')
      .child(sid)
      .child('pages')
      .child(historyKey)

      pageRef
        .child('focused')
        .set(false)

      pageRef
        .child('left_at')
        .set(firebaseApp.TIMESTAMP)

      pageRef
        .child('left_at')
        .onDisconnect()
        .cancel()

      pageRef
        .child('data')
        .child(historySubKey)
        .child('left_at')
        .set(firebaseApp.TIMESTAMP)

      pageRef
        .child('data')
        .child(historySubKey)
        .child('left_at')
        .onDisconnect()
        .cancel()

      commit('setHistorySid', null)
      commit('setHistoryKey', null)
      commit('setHistorySubKey', null)


  }
}
